/**
 * The correct answer, shown to a student once their own answer is final
 * (the server only sends it then). Used by the MCQ, subjective and
 * programming pages.
 */

import React from "react";

const box = {
  margin: "12px 0 0",
  padding: "12px 14px",
  borderRadius: 10,
  border: "1px solid #b7dfc6",
  background: "#f1faf4",
  fontSize: 14,
  lineHeight: 1.6,
  color: "#16232e",
};
const label = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: "#1f7a45", marginBottom: 6 };

export const AnswerReveal = ({ title, children, testId = "answer-reveal" }) => (
  <div style={box} data-testid={testId}>
    <div style={label}>{title}</div>
    {children}
  </div>
);

/** A reference text, or a note that the mentor didn't provide one (older questions). */
export const ReferenceText = ({ text, code = false }) => {
  if (!text) return <div style={{ color: "#6b7280" }}>Your mentor didn't add a reference answer for this question.</div>;
  if (code) {
    return (
      <pre style={{ margin: 0, whiteSpace: "pre-wrap", fontFamily: "ui-monospace, Menlo, monospace", fontSize: 13 }}>{text}</pre>
    );
  }
  return <div style={{ whiteSpace: "pre-wrap" }}>{text}</div>;
};

export const LOCKED_NOTE = "Your answer is final. You can still read it here, but it can't be changed.";
